import {Box, Typography} from '@mui/material';
import ArrModal from '../../../../../../common/arr-modal/ArrModal';
import {t} from 'i18next';
import './SwitchToManualModal.scss';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../../../../redux/store';
import {AI_REVIEW_JOB_TYPE} from '../../../../constant/AiReviewConstants';
import {setDefineCriteria} from '../../../../../../../redux/slice/aiReviewSlice';
import {CRITERIA} from '../IssueCodingTypeHeader';

interface SwitchToManualModalProps {
  open: boolean;
  onClose: () => void;
  setShowSwitchToManualModal: (val: boolean) => void;
  clearAllContents: () => void;
}
const SwitchToManualModal = ({
  open,
  onClose,
  setShowSwitchToManualModal,
  clearAllContents,
}: SwitchToManualModalProps) => {
  const jobType = useSelector((state: RootState) => state.aiReview.jobType);
  const dispatch = useDispatch();
  const handleConfirm = () => {
    clearAllContents();
    setShowSwitchToManualModal(false);
    dispatch(setDefineCriteria(CRITERIA.MANUAL));
  };

  return (
    <ArrModal
      className="arr-review-switch-manual-modal"
      showModal={open}
      onClose={onClose}
      showClose={false}
      title={t('ai.review.protocolIntelligence.switchToManualModalTitle')}
      aria-label={t('ai.review.protocolIntelligence.switchToManualModalTitle')}
      dataTestId="switch-manual-modal"
      buttons={[
        {
          id: 'cancel-btn',
          label: t('ai.review.leftPanel.cancelBtn'),
          onClick: onClose,
          variant: 'secondary',
          dataTestId: 'smm-cancel-button',
          className: 'cancel-button',
        },
        {
          id: 'switch-manual-btn',
          label: t('ai.review.protocolIntelligence.switchToManualBtn'),
          onClick: handleConfirm,
          variant: 'primary',
          dataTestId: 'switch-manual-btn',
          className: 'switch-manual-btn',
        },
      ]}
    >
      <Box className="switch-manual-modal-description">
        <Typography
          className=" typo-text body2_size"
          tabIndex={0}
          data-testid={`switch-to-manual-modal-typography`}
        >
          {jobType === AI_REVIEW_JOB_TYPE.issueCoding
            ? t('ai.review.protocolIntelligence.switchToManualModalDesc')
            : t('ai.review.protocolIntelligence.switchToManualModalDesc2')}
        </Typography>
      </Box>
    </ArrModal>
  );
};

export default SwitchToManualModal;
